import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Flusso,FlussoData } from '../data/flusso';
import { MessageHandlerService } from "../../services/message-handler.service"
import { EventEmitter } from '@angular/core';

@Injectable()
export class FlussoService extends FlussoData {

  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiFlusso: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  async deleteFlusso(id?) {
    try {
      let flyers = await this.http.delete(this.api + "flusso/" + (id || "")).toPromise();
      return flyers
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async createFlusso(data) {
    try {

      let response = await this.http.post(this.api + "flusso", data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getFlussi(pagination, filter, order) {
    console.log({ pagination, filter, order });
    try {
      let response = await this.http.post(this.api + "flussi", { pagination, filter, order }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getFlusso(id: string) {
    try {

      let flusso = <Flusso>await this.http.get(this.api + "flusso/" + id).toPromise();
      return flusso

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async duplicateFlusso(id: string) {
    try {

      let flusso = <Flusso>await this.http.get(this.api + "flusso/duplicate/" + id).toPromise();
      return flusso

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async editFlusso(data, id?: string) {
    try {

      let response = <Flusso>await this.http.put(this.api + "flusso/" + (id || ''), data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

}
